"use client";

import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "motion/react";
import { useTranslations } from "next-intl";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "./text-animation.css";

const items = [
  { imgUrl: "/images/icons/coin-gov.svg" },
  { imgUrl: "/images/icons/coin-gov2.svg" },
  { imgUrl: "/images/icons/coin-gov3.svg" },
  { imgUrl: "/images/icons/coin-gov4.svg" },
  { imgUrl: "/images/icons/coin-gov4.svg" },
];

const ShareResourceSection = () => {
  const t = useTranslations("governance");
  const resources = [
    {
      title: t("staking-rewards"),
      subtitle: t("for-securing-the-network-and-governance"),
      thumbnail: "/images/backgrounds/thumb-gov1.png",
      subThumnail: "/images/backgrounds/thum-gov11.png",
    },
    {
      title: t("grants"),
      subtitle: t("funding-for-builders-and-public-goods"),
      thumbnail: "/images/backgrounds/thumb-gov2.png",
      subThumnail: "/images/backgrounds/thum-gov12.png",
    },
    {
      title: t("incentives"),
      subtitle: t("rewards-that-bootstrap-adoption"),
      thumbnail: "/images/backgrounds/thumb-gov3.png",
      subThumnail: "/images/backgrounds/thum-gov13.png",
    },
  ];
  return (
    <section className="mx-auto max-w-[1440px] px-[78px] pb-20 pt-16 max-lg:px-10 max-sm:px-4">
      <div className="relative h-[340px] w-full max-sm:h-[200px]">
        <Image
          src={"/images/backgrounds/ongtoken.svg"}
          fill
          alt="vault"
          className="h-full w-full object-cover"
        />
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={3}
          freeMode={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={2000}
          loop={true}
          allowTouchMove={false}
          // breakpoints={{
          //     320: { slidesPerView: 2 },
          //     768: { slidesPerView: 3 },
          //     1024: { slidesPerView: 4 }
          // }}
          className="absolute top-[11%] w-[300px] translate-x-1 max-sm:w-[170px]"
          style={
            {
              "--swiper-wrapper-transition-timing-function": "linear",
            } as React.CSSProperties
          }
        >
          {items.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="flex items-center justify-center">
                <Image
                  width={50}
                  height={50}
                  src={item.imgUrl}
                  alt="Partner Logo"
                  className="pointer-events-none select-none"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="mx-auto -mt-32 flex max-w-[480px] flex-col items-center justify-center text-center max-lg:flex-col-reverse max-sm:-mt-16">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="text-base font-light text-[#646464] max-sm:text-sm">
            {t(
              "the-dao-treasury-powers-the-ecosystem-with-staking-rewards-grants-and-incentives-every-token-is-traceable-every-allocation-verifiable-ensuring-fairness-and-accountability",
            )}
          </p>
        </Reveal>
        <div className="mt-6 flex max-h-20 gap-2">
          <h2 className="text-[48px]/[56px] max-sm:text-[32px]/[40px]">
            {t("shared")}
          </h2>
          <div className="container">
            <div className="text-wrapper text-start text-[48px]/[56px] tracking-[-1px] text-[#06f] max-sm:text-[32px]/[40px]">
              <div className="">{t("resources")}</div>
              <div className="">{t("rewards")}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-14 grid grid-cols-3 max-lg:gap-2 max-sm:grid-cols-1">
        {resources.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, translateY: 40 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            transition={{ delay: 0.2 * index, duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
            className="rounded-2xl p-6 max-lg:border max-lg:border-[#0066FF]/[6%] max-lg:p-4 max-sm:shadow-sm"
          >
            {/* <div key={index} className={`p-6 rounded-2xl `}> */}
            <div className="relative flex items-center justify-center max-sm:max-h-[300px]">
              <Image
                src={item.thumbnail}
                fill
                alt="thumbnail"
                className="z-0"
              />
              <Image
                src={item.subThumnail}
                width={200}
                height={300}
                alt="subThumnail"
                className="z-10"
              />
            </div>
            <h4 className="mt-6 text-[32px]/[40px] tracking-[-1px] max-lg:text-xl">
              {item.title}
            </h4>
            <p className="text-lg font-light text-[#646464] max-lg:text-sm">
              {item.subtitle}
            </p>
            {/* </div> */}
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default ShareResourceSection;
